<p>error-dialog works!</p>
